import {observer} from "mobx-react-lite";
import React, { Fragment } from "react";
import {stores} from "../stores";
import {UTILITIES_NAMES} from "../model/preset";
import "./Utils.css";

export const Utils = observer(() => {

    function setName(index: number, name: string) {
        console.log("setName", index, name);
        stores.memory.setPresetName(name, index);
    }

    function saveChange(index: number, name: string) {
        // console.log("saveChange", index, name);
        // if (stores.memory.isPresetParamDirty("NAME", index) || (name !== stores.model.presetsNames[index].name)) {
        if (stores.memory.isPresetParamDirty("NAME", index)) {
            stores.midi.save(index);
        }
    }

    const offset = 100;

    return (
        <div className="utils main-content">
            <div className="p-20 mt-20 scroll-y utils-grid">
                {[...Array(6)].map((i, index)=>
                        // <div key={index} className="row center">
                <Fragment key={index}>
                            <div className="util-name">{UTILITIES_NAMES[index + offset] ?? ''}</div>
                            <div className={`preset-name`}>
                                <input type="text" value={stores.memory.getPresetName(index + offset)}
                                       onChange={e => setName(index + offset, e.currentTarget.value)}
                                       onBlur={e => saveChange(index + offset, e.currentTarget.value)}/></div>
                </Fragment>
                )}
            </div>
        </div>
    );

})